import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

const getters = {
  [getterTypes.GET_PAGE]: state => state.page,
};

const actions = {
  async [actionTypes.DO_GET_PAGE]({ commit }, payload) {
    const { id, ...params } = payload;
    const { data } = await HTTP.get(`/pages/${id}`, { params });
    commit(mutationTypes.SET_PAGE, data.data.pages[0]);
    return data;
  },
};

const mutations = {
  [mutationTypes.SET_PAGE](state, page) {
    state.page = page;
  },
};

export default {
  state: {
    page: {},
  },
  getters,
  actions,
  mutations,
};
